import { __exports as streamFlagApi } from "../../../../../../_virtual/stream-flag-api.js";
import { __require as requireStream } from "../transport/stream.js";
var hasRequiredStreamFlagApi;
function requireStreamFlagApi() {
  if (hasRequiredStreamFlagApi) return streamFlagApi;
  hasRequiredStreamFlagApi = 1;
  var __awaiter = streamFlagApi && streamFlagApi.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P ? value : new P(function(resolve) {
        resolve(value);
      });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      }
      function rejected(value) {
        try {
          step(generator["throw"](value));
        } catch (e) {
          reject(e);
        }
      }
      function step(result) {
        result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
  Object.defineProperty(streamFlagApi, "__esModule", { value: true });
  streamFlagApi.SdkStreamFlagApi = void 0;
  const stream_1 = requireStream();
  const DEFAULT_INITIAL_CONN_TIMEOUT = 1e3;
  const DEFAULT_TRY_ATTEMPTS = 2;
  const DEFAULT_TRY_WAIT_TIMEOUT = 1e3;
  class SdkStreamFlagApi {
    constructor(deploymentKey, serverUrl, eventSourceFactory, streamConnTimeoutMillis, streamFlagConnTimeoutMillis = DEFAULT_INITIAL_CONN_TIMEOUT, streamFlagTryAttempts = DEFAULT_TRY_ATTEMPTS, streamFlagTryDelayMillis = DEFAULT_TRY_WAIT_TIMEOUT) {
      this.isClosedAndNotTrying = true;
      this.api = new stream_1.SdkStream(deploymentKey, serverUrl + "/sdk/stream/v1/flags", eventSourceFactory, streamConnTimeoutMillis);
      this.streamFlagConnTimeoutMillis = Math.max(0, streamFlagConnTimeoutMillis);
      this.streamFlagTryAttempts = Math.max(1, streamFlagTryAttempts);
      this.streamFlagTryDelayMillis = Math.max(0, streamFlagTryDelayMillis);
    }
    // A try:
    // Try connect and receive at least one single flag update.
    connectTry(options) {
      let timeout = void 0;
      return new Promise((resolve, reject) => {
        const dealWithFlagUpdateInOneTry = (data) => __awaiter(this, void 0, void 0, function* () {
          if (timeout) {
            clearTimeout(timeout);
          }
          try {
            SdkStreamFlagApi.parseFlagConfigs(data);
          } catch (e) {
            return reject(stream_1.DEFAULT_STREAM_ERR_EVENTS.DATA_UNPARSABLE);
          }
          this.api.onUpdate = (data2) => this.handleNewMsg(data2, false);
          this.api.onError = (err) => this.errorAndRetry(err);
          try {
            yield this.handleNewMsg(data, true);
            resolve();
          } catch (_a) {
            reject();
          }
        });
        this.api.onUpdate = dealWithFlagUpdateInOneTry;
        const dealWithErrorInOneTry = (err) => __awaiter(this, void 0, void 0, function* () {
          if (timeout) {
            clearTimeout(timeout);
          }
          reject(err);
        });
        this.api.onError = dealWithErrorInOneTry;
        this.api.connect(options);
        timeout = setTimeout(() => {
          dealWithErrorInOneTry(stream_1.DEFAULT_STREAM_ERR_EVENTS.TIMEOUT);
        }, this.streamFlagConnTimeoutMillis);
      });
    }
    // Do try up to 2 times. If any of error is fatal, stop any further tries.
    // If trials times reached, fatal error.
    connect(options) {
      return __awaiter(this, void 0, void 0, function* () {
        if (!this.isClosedAndNotTrying) {
          return;
        }
        this.isClosedAndNotTrying = false;
        this.options = options;
        const attempts = this.streamFlagTryAttempts;
        const delay = this.streamFlagTryDelayMillis;
        for (let i = 0; i < attempts; i++) {
          try {
            return yield this.connectTry(options);
          } catch (e) {
            if (this.isClosedAndNotTrying) {
              return;
            }
            const err = e;
            if (this.isFatal(err) || i == attempts - 1) {
              this.close();
              throw err;
            }
            this.closeForRetry();
            yield new Promise((resolve) => setTimeout(resolve, delay));
            if (this.isClosedAndNotTrying) {
              return;
            }
          }
        }
      });
    }
    // Close stream.
    close() {
      this.closeForRetry();
      this.isClosedAndNotTrying = true;
    }
    // Close stream, but we know there will be another try happening very soon.
    closeForRetry() {
      this.api.close();
    }
    get isClosed() {
      return this.isClosedAndNotTrying;
    }
    // Fatal error if 501 Unimplemented.
    isFatal(err) {
      return err && (err === null || err === void 0 ? void 0 : err.status) == 501;
    }
    // If error during normal operation, retry init connection up to 2 times.
    errorAndRetry(err) {
      return __awaiter(this, void 0, void 0, function* () {
        if (this.isFatal(err)) {
          this.close();
          yield this.fatalErr(err);
        } else {
          this.close();
          this.connect(this.options).catch((err2) => {
            this.fatalErr(err2);
          });
        }
      });
    }
    // No more retry, 501 unimplemented. Need fallback.
    fatalErr(err) {
      return __awaiter(this, void 0, void 0, function* () {
        if (this.onError) {
          try {
            yield this.onError(err);
          } catch (_a) {
          }
        }
      });
    }
    // Handles new messages, parse them, and handoff to application. Retries if have parsing error.
    handleNewMsg(data, isInit) {
      return __awaiter(this, void 0, void 0, function* () {
        let flagConfigs;
        try {
          flagConfigs = SdkStreamFlagApi.parseFlagConfigs(data);
        } catch (e) {
          this.errorAndRetry(stream_1.DEFAULT_STREAM_ERR_EVENTS.DATA_UNPARSABLE);
          return;
        }
        const updateFunc = isInit && this.onInitUpdate ? this.onInitUpdate : this.onUpdate;
        if (updateFunc) {
          try {
            yield updateFunc(flagConfigs);
          } catch (e) {
            if (isInit) {
              throw e;
            }
          }
        }
      });
    }
    // Parse message. Throws if unparsable.
    static parseFlagConfigs(data) {
      const flagsArray = JSON.parse(data);
      return flagsArray.reduce((map, flag) => {
        map[flag.key] = flag;
        return map;
      }, {});
    }
  }
  streamFlagApi.SdkStreamFlagApi = SdkStreamFlagApi;
  return streamFlagApi;
}
export {
  requireStreamFlagApi as __require
};
//# sourceMappingURL=stream-flag-api.js.map
